import RootRoutes from "./routes/RootRoutes";

const App = () => {
    return (
        <>
         <RootRoutes/>
        </>
    )
}
export default App;